import React, { useEffect, useState, useRef, useContext } from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import {
    Container,
    Grid,
    Paper,
    CircularProgress,
    MenuItem,
    Divider
} from '@material-ui/core';
import { SelectLast10Request as TRANSACTION_LAST10 } from 'Components/Api/FundApi';

import { MaterialSelect } from 'Components/Inputes/FormikMaterialSelect';
import { MaterialCurrency } from 'Components/Inputes/MaterialCurrencyField';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import HOCLoader from 'Components/Loader/HOCLoader';
import { PrimaryButton, SecondaryButton } from 'Components/Inputes/CustomButton';
import { LOGOUT } from 'ConstComponents';
import { NumberToWord } from 'Components/WordConverter/CustomConverter';
import RechargeIcon from 'Components/SvgButtons/RechargeIcon';
import ResetIcon from 'Components/SvgButtons/ResetIcon';
import InputLabel from 'Components/Inputes/InputLabel';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import { BalanceContext } from 'Components/BalanceContext';
import ReactTable from 'Components/ReactTable/ReactTable';
import {
    PLEASE_SELECT_VALID,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import {
    SelectForFundTransfer as WALLET_SELECT
} from 'Components/Api/WalletApi';
import {

    CreditRequest as CREDIT_OPERATIONS,
    SelectByUserID as GET_REMAINING_LIMIT
} from 'Components/Api/CreditRequestAPI';
import { indianFormatNumber } from 'Components/utils';
const CustomContainer = HOCLoader(Container);

export const CreditRequest = () => {
    const classes = commonStyle();
    const formRef = useRef();
    const { DashboardBalanceUpdate } = useContext(BalanceContext);


    const [loadingOpen, setLoadingOpen] = useState(false);
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [severity, setSeverity] = useState('success');
    const [wallets, setWallets] = useState([]);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [remainingLimit, setRemainingLimit] = useState(0);
    const [maxLimit, setMaxLimit] = useState(0);
    const [usedAmount, setUsedAmount] = useState(0);
    const [dropDownOpen, setDropDownOpen] = useState(true);
    const [downlineReport, setDownlineReport] = useState([]);
    const [mainColumns, setMainColumns] = useState([]);
    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [InWords, setInWords] = useState('');

    const [currentUserID] = useState(localStorage.getItem('UserID'));
    const [formObj, setFormObj] = useState({
        WalletID: 0,
        Amount: '',
        Remark: '',
        InWords: '',
        Pin: '',
        IsPin: isPin
    });

    const validationSchema = Yup.object({
        WalletID: Yup.string()
            .notOneOf(['0'], PLEASE_SELECT_VALID + ' wallet')
            .required(PLEASE_SELECT_VALID + ' wallet'),

        Amount: Yup.number()
            .moreThan(0, PLEASE_PROVIDE_VALID + ' amount')
            .required(PLEASE_PROVIDE_VALID + ' amount'),

        Pin: Yup.number().when(['IsPin'], {
            is: (isPin) => isPin === 'true',
            then: Yup.number().required('Please enter pin')
        })
    });


    const fetchRemainingLimit = async () => {
        setLoadingOpen(true);
        const inputObj = {
            UserID: currentUserID
        }
        try {
            const { isAuthorized, status, data } = await GET_REMAINING_LIMIT(JSON.stringify(inputObj));

            if (!isAuthorized) LOGOUT();

            if (!status) {
                setResponseMessage(data);
                setIsError(true);
                setSeverity('error');
                return;
            }

            const limitData = JSON.parse(data);
            setRemainingLimit(limitData.AvailableAmount);
            setMaxLimit(limitData.MaxLimitAmount);
            setUsedAmount(limitData.UsedAmount);
        } catch (error) {
            setResponseMessage("Error fetching credit information");
            setIsError(true);
            setSeverity('error');
        } finally {
            setLoadingOpen(false);
        }
    };

    const selectWallets = async () => {
        setLoadingOpen(true);

        try {
            var request = { ID: 0 };
            var json = JSON.stringify(request);

            const { isAuthorized, status, data } = await WALLET_SELECT(json);

            if (!isAuthorized) LOGOUT();

            if (!status) {
                setResponseMessage(data);
                setIsError(true);
                setSeverity('error');
                return;
            }

            var d = JSON.parse(data);

            if (d.length <= 1) {
                setDropDownOpen(false);

                if (formRef.current) {
                    formRef.current.setFieldValue('WalletID', d[0].WalletID);
                }
            }

            setWallets(d);
        } catch (error) {
            setResponseMessage("Error fetching wallets");
            setIsError(true);
            setSeverity('error');
        } finally {
            setLoadingOpen(false);
        }
    };

    useEffect(() => {
        createColumns();
        SelectDownLineReport();
        fetchRemainingLimit();
        selectWallets();
    }, []);

    const handleSubmit = async (values, { setSubmitting }) => {
        if (loadingOpen) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(values);
        setSubmitting(false);
    };
    const processOperation = async (values) => {
        setIsAlertOpen(false);

        if (!values) return;

        setLoadingOpen(true);
        setIsError(false);

        try {
            const { isAuthorized, status, data } = await CREDIT_OPERATIONS(
                JSON.stringify(values)
            );
            if (!isAuthorized) LOGOUT();
            if (!status) {
                setSeverity('error');
                setResponseMessage(data);
                setIsError(true);
                return;
            }
            let responseData = JSON.parse(data);
            if (formRef.current) formRef.current.resetForm();
            setInWords('');


            setSeverity('success');
            setResponseMessage(responseData);
            setIsError(true);

            await DashboardBalanceUpdate();

            SelectDownLineReport();
            fetchRemainingLimit();
        } catch (error) {
            setSeverity('error');

        } finally {
            setLoadingOpen(false);
        }
    };


    const reset = () => {
        setInWords('');
        if (formRef.current) {
            formRef.current.resetForm(formObj);
        }
    };

    const OnChange = (value, setFieldValue) => {
        if (value === undefined || value <= 0) return;
        setInWords(NumberToWord(value));
        setFieldValue('InWords', NumberToWord(value));
    };
    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'FundTransactionID',
            srno: true
        });

        columns.push({
            label: 'Date',
            name: 'DOC'
        });

        columns.push({
            label: 'From',
            name: 'Sender'
        });

        columns.push({
            label: 'To',
            name: 'Receiver'
        });

        columns.push({
            label: 'Wallet',
            name: 'Wallet'
        });

        columns.push({
            label: 'Amount',
            name: 'Amount',
            numeric: true
        });

        columns.push({
            label: 'Status',
            name: 'Status',
            customStatus: true
        });

        columns.push({
            label: 'Remark',
            name: 'Remark'
        });

        setMainColumns(columns);
    };
    const SelectDownLineReport = async () => {


        setLoadingOpen(true);

        var response = await TRANSACTION_LAST10();
        setLoadingOpen(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            return;
        }
        createColumns();
        let data = JSON.parse(response.data);
        setDownlineReport(data);
    };
    return (
        <CustomContainer
            isLoading={loadingOpen}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObj}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ setFieldValue, values }) => (
                    <Grid
                        item
                        container
                        margin="normal"
                        xs={12}
                        md={12}
                        sm={12}
                        lg={12}
                        spacing={2}
                    >
                        <Grid item xs={12} sm={12} md={6} lg={4}>
                            <Form>
                                <h2 className={classes.PaperHead_h2}> Credit Request</h2>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container item spacing={3}>

                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <div className={classes.infoBox}>

                                                <div className={classes.infoItem}>
                                                    <h2 className={classes.recharge_h2}>
                                                        <span className={classes.Success_h3}>
                                                            Maximum Credit Limit:{" "}₹
                                                            {indianFormatNumber(Number(maxLimit || 0.0))}

                                                        </span>
                                                    </h2>
                                                    <h2 className={classes.recharge_h2}>
                                                        <span className={classes.Pending_h3}>
                                                            Available Credit:{" "}₹
                                                            {indianFormatNumber(Number(remainingLimit || 0.0))}

                                                        </span>
                                                    </h2>
                                                    <h2 className={classes.recharge_h2}>
                                                        <span className={classes.Fail_h3}>
                                                            Used Amount:{" "}₹
                                                            {indianFormatNumber(Number(usedAmount || 0.0))}

                                                        </span>
                                                    </h2>
                                                </div>
                                            </div>
                                        </Grid>

                                        {dropDownOpen && (
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <MaterialSelect
                                                    label="Wallet"
                                                    name="WalletID"
                                                    title="Select Wallet"
                                                >
                                                    <MenuItem key="0" value="0">
                                                        Select Wallet
                                                    </MenuItem>
                                                    {wallets.map((item) => (
                                                        <MenuItem
                                                            key={item.WalletID}
                                                            value={item.WalletID}
                                                        >
                                                            {item.ShortName}
                                                        </MenuItem>
                                                    ))}
                                                </MaterialSelect>
                                            </Grid>
                                        )}

                                        <Grid item xs={12} sm={12} md={12} lg={12}>
                                            <MaterialCurrency
                                                name="Amount"
                                                label="Amount"
                                                placeholder="Amount"
                                                autoComplete="new-password"
                                                max={remainingLimit}
                                                onCustomCallback={(value) => {
                                                    OnChange(value, setFieldValue);
                                                }}
                                            />
                                            <InputLabel
                                                color="green"
                                                value={InWords}
                                            />

                                        </Grid>



                                        {isPin === 'true' && (
                                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                                <MaterialNumberField
                                                    label="Pin"
                                                    type="password"
                                                    name="Pin"
                                                    placeholder="Pin"
                                                    title="Pin"
                                                    length={4}
                                                />
                                            </Grid>
                                        )}

                                        <Divider variant="middle" className="rechdevider" />

                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={12}
                                            lg={12}
                                            spacing={2}
                                            container
                                            className={classes.footerGrid}
                                        >
                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <SecondaryButton
                                                    type="reset"
                                                    disabled={loadingOpen}
                                                    endIcon={<ResetIcon />}
                                                    title="Reset"
                                                    className={classes.CustomDangerButtonStyle}
                                                    onClick={reset}
                                                >
                                                    Reset
                                                </SecondaryButton>
                                            </Grid>

                                            <Grid item xs={12} sm={12} md={6} lg={6}>
                                                <PrimaryButton
                                                    type="submit"
                                                    title="Request Credit"
                                                    endIcon={<RechargeIcon />}
                                                    className={classes.CustomPrimaryButtonStyle}
                                                    disabled={loadingOpen}
                                                >
                                                    Request Credit
                                                </PrimaryButton>
                                                {loadingOpen && (
                                                    <CircularProgress
                                                        size={24}
                                                        className={classes.buttonProgress}
                                                    />
                                                )}
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Form>
                        </Grid>

                        <Grid
                            item
                            xs={12}
                            sm={12}
                            md={6}
                            lg={8}
                            className="lastrecharges"
                        >
                            <h2 className={classes.PaperHead_h2}>Last 10 Fund</h2>
                            <ReactTable
                                data={downlineReport}
                                columns={mainColumns}
                                headerToolbar={false}
                                footerToolbar={false}
                            />
                        </Grid>
                    </Grid>
                )}
            </Formik>

            {isAlertOpen && (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="Credit Request"
                    message="Are you sure you want to request this credit amount?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        processOperation(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            )}
        </CustomContainer>
    );
};

export default CreditRequest;